import { VFC } from "types";
import { useState } from "react";
import AsyncSelect from "react-select/async";
import type { SingleValue } from "react-select";
import client from "libs/client";

export type AssignSubscriptionClubOption = { label: string | number; value: string | number };

export type AssignSubscriptionClubSelection = SingleValue<AssignSubscriptionClubOption> | undefined;

interface AssignSubscriptionModalProps {
	onClose: () => void;
	onAssignSubscription: (values: AssignSubscriptionClubSelection) => void;
}

const AssignSubscriptionModal: VFC<AssignSubscriptionModalProps> = ({ onClose, onAssignSubscription }) => {
	const [selectedClub, setSelectedClub] = useState<AssignSubscriptionClubSelection>();

	const onAssign = () => {
		onAssignSubscription(selectedClub);
	};

	const clubSearch = async (term: string): Promise<{ label: string | number; value: string | number; }[] | []> => {
		if (term === "") return [];
		return await client.clubProSearch.query({search : term}).then((res) => { return res?.data }) as { label: string | number; value: string | number; }[];
	};

	return (
		<>
			<div className="form-group flex-column">
				<label className="required">Assign to</label>
				<AsyncSelect
					cacheOptions
					loadOptions={clubSearch}
					value={selectedClub}
					isClearable={true}
					placeholder="Search"
					className={"react-select"}
					onChange={(e: SingleValue<AssignSubscriptionClubOption>) => {
						setSelectedClub(e ?? undefined);
					}}
				/>
			</div>
			<div className="form__footer">
				<button className="btn-primary btn" onClick={() => onAssign()}>
					Assign
				</button>
				<button className="btn--cancel" onClick={() => onClose()}>
					Cancel
				</button>
			</div>
		</>
	);
};

export default AssignSubscriptionModal;
